"use client";

export default function HeroSection() {
  return (
    <section className="bg-cream py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
        <div className="flex-1 space-y-6">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-orange text-white text-sm font-semibold">
            EMERGENCY SERVICE
          </div>
          <h1 className="text-3xl md:text-[42px] font-bold text-secondary leading-tight">
            Emergency Window Board-Up Miami
          </h1>
          <p className="text-base md:text-lg text-gray-600 max-w-xl">
            Same-day temporary plywood protection after storm damage, break-ins, or accidental breakage.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="tel:+17863774452"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-orange hover:bg-orange/90 text-white font-semibold rounded-md transition-colors whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              Call Now (786) 377-4452
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center px-6 py-3 border-2 border-secondary text-secondary font-semibold rounded-md hover:bg-secondary hover:text-white transition-colors whitespace-nowrap"
            >
              Get Phone Quote
            </a>
          </div>
        </div>
        <div className="flex-1 flex justify-center lg:justify-end">
          <img
            src="https://storage.readdy-site.link/project_files/76915537-ee3f-4564-9a23-41bd98b5df27/79687bfe-99ba-4369-bc45-80c23a2d346a_Emergency-Board-Up-miami.jpeg?v=3d046b460ca76ae2581538c937afd02b"
            alt="Emergency hurricane plywood board-up service Miami"
            className="rounded-xl w-full max-w-[520px] h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}